<template>
  <b-card>
    <b-card-header>{{ title }}</b-card-header>
    <b-card-body>
      <bar-chart v-if="statData" :chart-data="statData" :options="statOpts"></bar-chart>
    </b-card-body>
  </b-card>
</template>
<script>
import BarChart from "../../components/chart/BarChart.js";
import { Api } from "../../lib/api";
const api = new Api();

export default {
  name: "barchartdash",
  components: { BarChart },
  props: { url: String, refresher: Number, title: String },
  data() {
    return {
      statData: null,
      statOpts: {
        responsive: true,
        height: "200px",
        position: "relative",
        maintainAspectRatio: false,
      },
      colors: ["#6c9381", "#3f554b", "#98b3a7", "#73d9a9"],
    };
  },
  created() {
    this.RefreshStats();
  },
  watch: {
    refresher: function () { this.RefreshStats() },
    url: function () { this.RefreshStats() }
  },
  methods: {
    RefreshStats() {
      api.get(this.url).then((res) => {
        this.statData = res.data;
        for (var i = 0; i < this.statData.datasets.length; i++)
          this.statData.datasets[i].backgroundColor = this.colors[i];
      });
    },
  },
};
</script>